
import { defineComponent, ref, computed, onMounted, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { usePopupStore } from '@/store/popup'
import { useReadingResultStore, ReadingResultList } from '@/store/readingResult'
import { usePacsStore } from '@/store/pacs';
import Pagenation from "@/components/Pagenation.vue";
import { usePageStore } from '@/store/pagenation';
import { debounce } from 'lodash';
import 'v-calendar/dist/style.css';
import moment from 'moment';
import lodash from 'lodash';
import VCalendar from 'v-calendar'

export default defineComponent({
  components: {
    Pagenation,
  },
  props:{
  },
  setup(props, {emit}) {
    const checkAll = ref(false);
    const popupStore = usePopupStore();
    const pacsStore = usePacsStore();
    const thumbnailUrl = ref();
    const loading = ref(false);
    const targetUID = ref("");
    const showThumbnail = ref(false);
    const mouseEnter = ref(false);
    const searchText = ref("");
    const isComposing = ref(false);
    const selectedCount = ref(0);
    const currPage = computed(() => usePageStore().getCurrPage);
    const selectBoxOpen = ref(false);
    const selectedOption = ref("Study Date");
    const pacsData = computed(() => pacsStore.getPacsData);
    const currPageData = computed(() => pacsStore.getCurrPageData);
    const placeholder = ref("Patient ID");
    
    const today = new Date()
    type Range = { start: Date | null; end: Date | null };
    const range = ref<Range>({
      start: today,
      end: today,
    });
    const preRange = ref(lodash.cloneDeep(range.value));
    const MAX_RANGE = 13;

    const attributes = ref<any[]>([]);
    const calendarKey = ref(0);

    async function handleSelect(value: { start: Date | null; end: Date | null }) {
      const start = value?.start ? new Date(value.start) : null;
      const end = value?.end ? new Date(value.end) : null;
      

      if (start && !end) return;

      if (start && end) {
        const diff =
          Math.abs(end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);

        if (diff > MAX_RANGE) {
          
          alert(`최대 ${MAX_RANGE+1}일까지만 선택할 수 있습니다.`);
          range.value = { start: preRange.value.start, end: preRange.value.end };

          attributes.value = [];
          calendarKey.value += 1;

          await nextTick();
          return;
        }

        attributes.value = [
          {
            key: 'range',
            highlight: true,
            dates: { start, end },
          },
        ];
        preRange.value = {start: start, end: end}
      }
    }

    async function initSelect() {
      range.value = { start: null, end: null };

      attributes.value = [];
      calendarKey.value += 1;

      await nextTick();
    }

    const disabledDates = ref<Range[]>([]);
    const selectedDate = ref<Date | null>(null);
    
    function formatDate(d: Date) {
      if (!d) return '';
      return `${d.getFullYear()}.${(d.getMonth()+1).toString().padStart(2,'0')}.${d.getDate().toString().padStart(2,'0')}`;
    }

    const itemsPerPage = 18;
    const setPageData = () => {
      selectedCount.value = 0;
      checkAll.value = false;
      const startIndex = (currPage.value - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      pacsStore.setCurrPageDate([]);
      for (let i = startIndex; i < endIndex && i < pacsData.value.length; i++) {
        currPageData.value.push({
          ...pacsData.value[i],
          selected: false
        });
      }
    }

    const handleMouseEnterDate = () => {
      mouseEnter.value = true;
    }

    const handleMouseLeaveDate = () => {
      mouseEnter.value = false;
    }

    const closePopup = () => {
      popupStore.togglePopup('pacs', false);
    }

    const selectAllList = (check: boolean) => {
      checkAll.value = check;

      for (let i = 0; i < currPageData.value.length; i++) {
        currPageData.value[i].selected = checkAll.value;
      }
      if(check) {
        selectedCount.value = currPageData.value.length;
      } else {
        selectedCount.value = 0;
      }
    }

    const selectList = (list: any) => {
      list.selected = !list.selected;

      selectedCount.value = currPageData.value.reduce(
        (count: number, item: any) => count + (item.selected ? 1 : 0), 0
      );

      checkAll.value = true;
      for (let i = 0; i < currPageData.value.length; i++) {
        if(!currPageData.value[i].selected) {
          checkAll.value = false;
          break;
        }
      }
    }

    const handleUploadBtnClick = async () => {
      if(selectedCount.value > 0) {
        popupStore.togglePopup('nowLoading', true);
        const uploadRes = await pacsStore.uploadPacsData();
        if(uploadRes) {
          selectAllList(false);
        }
      }
    }

    const handleThumbnailClick =  async (uid: string): Promise<void> => {
      if(uid == targetUID.value) {
        showThumbnail.value = false;
        targetUID.value = "";
      } else {
        showThumbnail.value = true;
        targetUID.value = uid;
        loading.value = true;
        thumbnailUrl.value = await pacsStore.getPacsThumbnail(uid);
        if(thumbnailUrl.value != null) {
          loading.value = false;
        }
      }
    }

    const toggleSelectBox = () => {
      selectBoxOpen.value = !selectBoxOpen.value;
    }

    const handleClickOption = (option: string) => {
      selectedOption.value = option;

      if(option == "ID") {
        placeholder.value = "Patient ID"
      } else {
        placeholder.value = "Patient Name"
      }
    }

    const handlePacsSettingBtn = () => {
      popupStore.togglePopup('pacs', false);
      popupStore.togglePopup('pacsSetting', true);
    }
    
    const handleSearchBtnClick = () => {
      if(searchText.value.length > 0 ||  selectedOption.value == 'Study Date') {
        searchPacsData();
      }
    }

    const searchPacsData = debounce(() => {
      let studyDate = "";

      if(range.value.start != null && range.value.end != null) {
        studyDate = `${moment(range.value.start).format('YYYYMMDD')}-${moment(range.value.end).format('YYYYMMDD')}`;
      }

      if (selectedOption.value === "ID") {
        pacsStore.searchPacsData(searchText.value, "", "", currPage.value);
      } else if((selectedOption.value === "Name")) {
        pacsStore.searchPacsData("", searchText.value, "", currPage.value);
      } else if(selectedOption.value == "Study Date") {
        pacsStore.searchPacsData("", "", studyDate, currPage.value);
      }

      showThumbnail.value = false;
      targetUID.value = "";
      
    }, 400);

    const formatStudyDate = (date: string) => {
      if (/^\d{8}$/.test(date)) {
        return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
      }
      return date;
    };

    function formatPatientAge(rawAge: string) {
      if (!rawAge) return '-';

      rawAge = rawAge.trim();

      if (rawAge.toLowerCase() === 'anonymized') return 'Anonymized';

      const match = rawAge.match(/^(\d+)([YMWD])$/i);
      if (match) {
        const value = parseInt(match[1], 10);
        const unit = match[2].toUpperCase();

        switch (unit) {
          case 'Y':
            return `${value}세`;
          case 'M':
            return `${value}개월`;
          case 'W':
            return `${value}주`;
          case 'D':
            return `${value}일`;
        }
      }

      return rawAge;
    }

    watch(pacsData, (newVal) => {
      setPageData();
    });

    watch(currPage, (newVal) => {
      setPageData();
    });

    onMounted(() => {
      setPageData();
      selectAllList(false);
      pacsStore.initUploadProgress();
    });

    return {
      closePopup,
      checkAll,
      selectAllList,
      selectList,
      formatStudyDate,
      handleMouseEnterDate,
      handleMouseLeaveDate,
      pacsData,
      handleUploadBtnClick,
      range,
      disabledDates,
      searchText,
      handleThumbnailClick,
      thumbnailUrl,
      loading,
      targetUID,
      showThumbnail,
      mouseEnter,
      searchPacsData,
      selectedCount,
      toggleSelectBox,
      selectBoxOpen,
      handleClickOption,
      selectedOption,
      placeholder,
      isComposing,
      handlePacsSettingBtn,
      formatPatientAge,
      attributes,
      selectedDate,
      formatDate,
      handleSelect,
      calendarKey,
      initSelect,
      handleSearchBtnClick,
      currPageData
    };
  },
});
